import React from 'react';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Switch,
} from '@material-ui/core';
import moment from 'moment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/Close';
import {
  deleteOfferAsync,
  getAllOffersAsync,
  updateOfferStatusAsync,
} from './OfferStore/offerStoreSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ViewDetails from './ViewDetails';

export const offerColumn = [
  { Header: 'Offer Name', accessor: 'title' },
  { Header: 'Domain', accessor: 'domain' },
  { Header: 'Amount in %', accessor: 'amount' },
  { Header: 'Code', accessor: 'code' },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { _id, domain, status, expiredAt } = payload;

      var today = new Date();
      var date1 = moment(today).format('YYYY-MM-DD');
      var date2 = moment(expiredAt).format('YYYY-MM-DD');

      const dispatch = useDispatch();
      // React.useEffect(() => {
      //   fetchData();
      // }, [status]);

      const fetchData = async () => {
        try {
          dispatch(
            getAllOffersAsync({
              params: {
                offerDomain: domain,
              },
            })
          )
            .unwrap()
            .then(() => {
              // toast.success('All offers were fetched successfully!');
            });
        } catch (error) {
          toast.error('Offers could not be fetched. Please try again!');
        }
      };

      const handleUpdateOfferStatus = async () => {
        try {
          let payload = {
            offerId: _id,
            status:
              status === 'INACTIVE'
                ? 'ACTIVE'
                : 'ACTIVE'
                ? 'INACTIVE'
                : 'INACTIVE',
            domain: domain,
          };
          dispatch(updateOfferStatusAsync(payload))
            .unwrap()
            .then((res) => {
              toast.success(`Offer has been updated successully!`);
              fetchData();
            });
        } catch (error) {
          toast.error('Offer not updated!');
        }
      };

      return (
        <>
          {date1 <= date2 ? (
            <Switch
              checked={status === 'ACTIVE' ? true : false}
              onChange={() => handleUpdateOfferStatus()}
              name="loading"
              color="primary"
            />
          ) : (
            <Switch
              checked={false}
              onChange={() => handleUpdateOfferStatus()}
              name="loading"
              color="primary"
              disabled={true}
            />
          )}
        </>
      );
    },
  },
  {
    Header: 'Expired',
    accessor: 'expiredAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { expiredAt } = payload;
      var today = new Date();
      var date1 = moment(today).format('YYYY-MM-DD');
      var date2 = moment(expiredAt).format('YYYY-MM-DD');
      return (
        <>
          {date1 <= date2 ? (
            <Box>{moment(expiredAt).format('MMMM Do, YYYY')}</Box>
          ) : (
            <Box sx={{ color: '#A30000', fontWeight: 'bold' }}>
              {moment(expiredAt).format('MMMM Do, YYYY')}
            </Box>
          )}
        </>
      );
    },
  },
  {
    Header: 'Action',
    accessor: '_id',
    Cell: (val) => {
      const payload = val.cell.row.original;

      const { _id, domain } = payload;

      const [anchorEl, setAnchorEl] = React.useState(null);
      const dispatch = useDispatch();
      const [open1, setOpen1] = React.useState(false);
      const handleOpen1 = () => setOpen1(true);
      const handleClose1 = () => setOpen1(false);

      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
      const ITEM_HEIGHT = 48;

      // React.useEffect(() => {
      //   fetchData();
      // }, []);

      const fetchData = async () => {
        try {
          dispatch(
            getAllOffersAsync({
              params: {
                offerDomain: domain,
              },
            })
          )
            .unwrap()
            .then(() => {
              // toast.success('All offers were fetched successfully!');
            });
        } catch (error) {
          toast.error('Offers could not be fetched. Please try again!');
        }
      };

      const handleDelete = async () => {
        try {
          dispatch(deleteOfferAsync(_id))
            .unwrap()
            .then((res) => {
              toast.success(`Offer has been Deleted successully!`);
              fetchData();
            });
          handleClose();
        } catch (error) {
          toast.error('Offer not Deleted!');
        }
      };

      return (
        <Box display="flex">
          <Box width={80} fontSize={14}>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                },
              }}>
              <MenuItem onClick={handleOpen1}>View Details</MenuItem>
              {/* <MenuItem>
                <Switch
                  checked={status === 'ACTIVE' ? true : false}
                  onChange={() => handleUpdateOfferStatus()}
                  name="loading"
                  color="primary"
                />
                Update Status
              </MenuItem> */}
              <MenuItem onClick={() => handleDelete()}>Delete</MenuItem>
            </Menu>
          </Box>
          <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <>
              <CloseIcon />
              <ViewDetails id={_id} handleClose={handleClose} />
            </>
          </Modal>
        </Box>
      );
    },
  },
];
